import { useAuthStore } from '@/stores/auth.ts';
import { acceptHMRUpdate, defineStore } from 'pinia';
import { useApi } from '@/composables/use-api.ts';
import { AttendanceMonthDto } from '@/services/api/attendance-month-api.ts';

interface State {
  ymToAm: { [key: string]: AttendanceMonthDto };
}

export const useAttendanceMonthStore = defineStore('attendance-month', {
  state: (): State => {
    return {
      ymToAm: {},
    };
  },

  actions: {
    async getAsync(yearMonth: string) {
      let am = this.ymToAm[yearMonth];
      if (!am) {
        const { attendance } = useApi();

        const authStore = useAuthStore();
        this.ymToAm[yearMonth] = am = await attendance.month.getAsync(
          authStore.flexUser.employee?.no ?? 0,
          yearMonth
        );
      }
      return am;
    },

    async deadlineAsync(yearMonth: string) {
      const { attendance } = useApi();
      this.ymToAm[yearMonth] = await attendance.month.deadlineAsync(yearMonth);
    },
  },
});

if (import.meta.hot) {
  import.meta.hot.accept(
    acceptHMRUpdate(useAttendanceMonthStore, import.meta.hot)
  );
}
